//LOCAL
export const url = {
    hc_base: process.env.REACT_APP_API_BASE_HC,
    hc_base_career: process.env.REACT_APP_API_BASE_HC+"Career/",
    EGESBaseUrl: "https://clg.icicibank.com/EGESCareers/",
    hcmasterUrl: process.env.REACT_APP_API_BASE_HC+"hc/master/",
    Our_url: process.env.REACT_APP_API_BASE_MG,
    AllincallUrl: "https://step-icicihr.allincall.in/",
    AllincallUrlCRM: "https://icicihr.allincall.in/",
    OurApplicationUrl: "http://localhost:53569/",
    hcApplicants: process.env.REACT_APP_API_BASE_HC+"Applicants/",
    localhost3001: "http://localhost:3001/",
    teamicici:"https://magittdev.expresssolutions.in/TeamICICIApi/"
  
     
};

//UAT
// export const url = {
//     base: "https://clg.icicibank.com/Hc_IbankApi/Career/",
//     EGESBaseUrl: "https://clg.icicibank.com/EGESCareers/",
//     hcmasterUrl: "https://clg.icicibank.com/Hc_IbankApi/hc/master/",
//     Our_url: "https://clg.icicibank.com/CareerApplicantAoi/",
//     AllincallUrl: "https://step-icicihr.allincall.in/",
//     AllincallUrlCRM: "https://icicihr.allincall.in/",
//     hcApplicants: "https://clg.icicibank.com/Hc_IbankApi/Applicants/"
// };

//LIVE
// export const url = {
//     Our_url: 'https://www.icicicareers.com/CareerApplicantApi/',
// };